function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { useContext, useState } from "react";
import { twMerge } from "@stereoagency/tailwind-config";
import { autoUpdate, offset, safePolygon, shift, useFloating, useHover, useInteractions } from "@floating-ui/react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowRight } from "../../visuals";
import { useBreakpoint } from "../../hooks";
import { slowSpring } from "../../motion/transitions";
import { fadeInHeight } from "../../motion/variants";
import ReactConfigContext from "../../ReactConfigContext";
var defaultFloatingMiddleware = [
    shift({
        padding: {
            left: 32
        }
    }),
    offset({
        mainAxis: 15,
        crossAxis: -24
    })
];
export default function NavigationItem(param) {
    var active = param.active, icon = param.icon, action = param.action, submenu = param.submenu, middleware = param.middleware, className = param.className;
    var _useContext = useContext(ReactConfigContext), LinkComponent = _useContext.config.LinkComponent;
    var _useState = _sliced_to_array(useState(false), 2), isOpen = _useState[0], setIsOpen = _useState[1];
    var _useBreakpoint = useBreakpoint(), maxWidth = _useBreakpoint.maxWidth, BREAKPOINTS = _useBreakpoint.BREAKPOINTS;
    var isTabletOrMobile = typeof maxWidth === "number" && maxWidth <= BREAKPOINTS.md;
    var hasSubmenu = !!(submenu === null || submenu === void 0 ? void 0 : submenu.length);
    var _useFloating = useFloating({
        placement: "bottom-start",
        open: isOpen,
        onOpenChange: setIsOpen,
        whileElementsMounted: autoUpdate,
        middleware: middleware !== null && middleware !== void 0 ? middleware : defaultFloatingMiddleware
    }), refs = _useFloating.refs, floatingStyles = _useFloating.floatingStyles, context = _useFloating.context;
    var hover = useHover(context, {
        enabled: !isTabletOrMobile,
        handleClose: safePolygon({
            blockPointerEvents: true
        })
    });
    var _useInteractions = useInteractions([
        hover
    ]), getReferenceProps = _useInteractions.getReferenceProps, getFloatingProps = _useInteractions.getFloatingProps;
    var triggerCx = twMerge("flex items-center justify-center font-semibold font-heading text-navigation-lg transition-all text-center", "hover:text-link-fg-base md:text-navigation-base md:text-left", active && "text-link-fg-base underline decoration-link-fg-base decoration-2 underline-offset-8 md:underline-offset-[1em]", action.className);
    var handleClick = function(event) {
        if (isTabletOrMobile && hasSubmenu) {
            event.preventDefault();
            setIsOpen(!isOpen);
        }
    };
    var submenuItems = /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 grid-flow-row auto-rows-max gap-6"
    }, submenu === null || submenu === void 0 ? void 0 : submenu.map(function(item) {
        return /*#__PURE__*/ React.createElement("div", {
            key: "item-".concat(item.href),
            className: "md:min-w-[15rem]"
        }, /*#__PURE__*/ React.createElement(LinkComponent, _object_spread_props(_object_spread({}, item), {
            className: twMerge("font-semibold font-heading text-fg-inverted text-navigation-base group", "flex items-center justify-center opacity-60 text-center", "hover:opacity-100 md:justify-start md:opacity-100 md:text-left", item.className)
        }), !isTabletOrMobile && /*#__PURE__*/ React.createElement("span", {
            className: "mr-5 transition-all group-hover:translate-x-2"
        }, /*#__PURE__*/ React.createElement(ArrowRight, null)), /*#__PURE__*/ React.createElement("span", null, item.label)));
    }));
    return /*#__PURE__*/ React.createElement("div", {
        className: className
    }, /*#__PURE__*/ React.createElement("div", _object_spread({
        ref: !isTabletOrMobile && hasSubmenu ? refs.setReference : undefined
    }, !isTabletOrMobile && hasSubmenu ? getReferenceProps() : {}), action.href ? /*#__PURE__*/ React.createElement(LinkComponent, _object_spread_props(_object_spread({}, action), {
        href: action.href,
        className: triggerCx,
        onClick: handleClick
    }), /*#__PURE__*/ React.createElement("span", null, action.label), !!icon && /*#__PURE__*/ React.createElement("span", {
        className: "ml-4"
    }, icon)) : /*#__PURE__*/ React.createElement("button", {
        type: "button",
        className: triggerCx,
        onClick: handleClick
    }, /*#__PURE__*/ React.createElement("span", null, action.label), !!icon && /*#__PURE__*/ React.createElement("span", {
        className: "ml-2"
    }, icon)), /*#__PURE__*/ React.createElement(AnimatePresence, null, hasSubmenu && isOpen && isTabletOrMobile && /*#__PURE__*/ React.createElement(motion.div, {
        variants: fadeInHeight,
        initial: "hide",
        exit: "hide",
        animate: "show",
        className: "overflow-hidden",
        transition: slowSpring
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mt-6"
    }, submenuItems)))), hasSubmenu && isOpen && !isTabletOrMobile && /*#__PURE__*/ React.createElement("div", _object_spread({
        ref: refs.setFloating,
        style: floatingStyles
    }, getFloatingProps()), /*#__PURE__*/ React.createElement("div", {
        className: "bg-blue-500 rounded-xl py-7 px-6"
    }, submenuItems)));
}

//# sourceMappingURL=NavigationItem.js.map